<template>
  <div class="quiz">
    <div role="status">
      <div
        v-if="isLoadingResults"
        class="quiz__loading-wrapper"
      >
        <div class="quiz__loading-message">
          <slot name="loading" />
        </div>
        <span class="quiz__loading-bar" />
      </div>
    </div>

    <slot
      v-if="showNewsletterForm"
      name="newsletter"
    />

    <div
      v-else-if="started"
      class="questions-wrapper"
    >
      <slot name="steps" />
      <slot
        name="quiz"
        :active-question-id="activeQuestion.id"
        :questions="questionList"
      />
      <slot
        name="control"
        :back="goBack"
        :disable-back="!previousQuestion"
        :disable-next="disableNextButton"
        :next="goNext"
        :required-error="requiredError"
        :required-field-error-message="activeQuestion.nextCtaErrorMessage"
      />
      <div class="quiz__disclaimer">
        <slot name="disclaimer" />
      </div>
    </div>

    <slot
      v-else
      name="initial"
      :start="start"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { eventBus } from '@Foundation/eventbus/eventbus';
  import { types } from '../constants';

  const { INIT_QUIZ, NEXT, SEND_RESULTS, UPDATE_NEWSLETTER_FORM_DISPLAY } = types;

  export default {
    name: 'Quiz',
    props: {
      apiUrl: {
        type: String,
        required: true
      },
      newsletterActive: {
        default: false,
        type: Boolean,
      },
      questions: {
        type: Array,
        required: true
      },
      changeQuestionsOnSelection: {
        type: Boolean,
        required: false,
        default: false
      },
      questionDelayMilliseconds: {
        type: Number,
        required: false,
        default: null
      },
      resultsPage: {
        required: true,
        type: String,
      },
      tooltipCommon: {
        default: null,
        type: Object,
      },
    },
    computed: {
      ...mapGetters('skincareV2Store', [
        'isLoadingResults',
        'showNewsletterForm',
        'started',
        'activeQuestion',
        'questionList',
        'final',
        'requiredError'
      ]),
      activeQuestionIndex() {
        return this.questionList.findIndex(({ id }) => id === this.activeQuestion.id);
      },
      previousQuestion() {
        return this.questionList[this.activeQuestionIndex - 1];
      },
      nextQuestion() {
        return this.questionList[this.activeQuestionIndex + 1];
      },
      disableNextButton() {
        return !this.final
          ? !this.nextQuestion || (this.activeQuestion && !this.activeQuestion.validated)
          : !this.activeQuestion.validated;
      },
    },
    mounted() {
      this[INIT_QUIZ]({
        questions: this.questions,
        config: {
          apiUrl: this.apiUrl,
          changeQuestionsOnSelection: this.changeQuestionsOnSelection,
          newsletterActive: this.newsletterActive,
          questionDelayMilliseconds: this.questionDelayMilliseconds,
          resultsPage: this.resultsPage,
          tooltipCommon: this.tooltipCommon,
        }
      });

      eventBus.$on('skincare-newsletter', (newsletterData) => {
        this[UPDATE_NEWSLETTER_FORM_DISPLAY](false);
        this[SEND_RESULTS](newsletterData);
      });
    },
    methods: {
      ...mapActions('skincareV2Store', [
        INIT_QUIZ,
        NEXT,
        SEND_RESULTS,
        'start',
        UPDATE_NEWSLETTER_FORM_DISPLAY,
        'back',
      ]),
      goBack() {
        if (this.previousQuestion) {
          this.back();
        }
      },
      goNext() {
        this[NEXT]();
      }
    }
  };
</script>
